/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from '@tanstack/react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import {Blog} from './_models'
import {useQueryRequest} from './QueryRequestProvider'
import {v2_get_request_api} from '../../../../../../api/get'

const QueryResponseContext = createResponseContext<Blog>(initialQueryResponse)
const QueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery([QUERIES.BLOG_LIST, query], v2_get_request_api)

  return (
    <QueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query, state}}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {response} = useQueryResponse()
  if (!response) {
    return []
  }

  return response?.entities || []
}

const useQueryResponsePagination = () => {
  const {response, state} = useQueryResponse()
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
    total: response?.total_count,
  }

  if (!state) {
    return defaultPaginationState
  }

  return {...state, total: response?.total_count, count: response?.entities?.length}
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
